<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
  page: {
    title: "Procedimiento matriz de identificación peligros del sg-sst.",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/",
        },

        {
          text: "Procedimiento matriz de identificación peligros del sg-sst.",
          active: true,
        },
      ],
      text: `
         ... `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />



    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title">Procedimiento matriz de identificación peligros del SG-SST</h4>
            <div class="row">
              <div class="col-12 text-right m-b-0">
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
              </div>
            </div>
            <hr />

            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                  <b-list-group-item href="#list-item-1">Objetivo</b-list-group-item>
                  <b-list-group-item href="#list-item-2">Alcance</b-list-group-item>
                  <b-list-group-item href="#list-item-3">Definiciones</b-list-group-item>
                  <b-list-group-item href="#list-item-4">Actividades </b-list-group-item>
                  <!--  <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->


                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div id="listgroup-ex" style="position: relative; overflow-y: auto; height: 300px">
                  <h4 id="list-item-1">Objetivo </h4>
                  <p>Identificar peligros y valorar los riesgos a los cuales se encuentran expuestos los empleados,
                    contratistas, subcontratistas y visitantes de la empresa y determinar los controles necesarios para la
                    reducción del riesgo, prevenir los incidentes, enfermedades laborales y pérdidas materiales. </p>
                  <h4 id="list-item-2">Alcance</h4>
                  <p>Este procedimiento aplica para todos los procesos, actividades y servicios desarrollados por la
                    empresa, se aplicará a toda identificación, valoración y determinación de controles de los riesgos que
                    afecten la seguridad y salud de los trabajadores, contratistas, subcontratistas y visitantes. </p>
                  <h4 id="list-item-3">Definiciones</h4>
                  <p><b>Accidente de trabajo:</b> Es accidente de trabajo todo suceso repentino que sobrevenga por causa o
                    con ocasión del trabajo, y que produzca en el trabajador una lesión orgánica, una perturbación
                    funcional o psiquiátrica, una invalidez o la muerte.<br />
                    <b>Actividad rutinaria:</b> Actividad que forma parte de la operación normal de la organización, se ha
                    planificado y es estandarizable
                    <b>Actividad no rutinaria:</b> Actividad que no forma parte de la operación normal de la organización,
                    que no es estandarizable debido a la diversidad de escenarios y condiciones bajo las cuales pudiera
                    presentarse. <br />
                    <b>Consecuencia:</b> Resultado, en términos de lesión o enfermedad, de la materialización de un
                    riesgo, expresado cualitativa o cuantitativamente. <br />
                    <b>Competencia:</b> Atributos personales y aptitud demostrada para aplicar conocimientos y
                    habilidades. <br />
                    <b>Diagnóstico de condiciones de trabajo:</b> Resultado del procedimiento sistemático para
                    identificar, localizar y valorar “aquellos elementos, agentes o factores que tienen influencia
                    significativa en la generación de riesgos para la seguridad y salud de los trabajadores. <br />
                    <b>Enfermedad:</b> Condición física o mental adversa identificable, que surge, empeora o ambas, a
                    causa de una actividad laboral, una situación relacionada con el trabajo o ambas. <br />
                    <b>Enfermedad Laboral:</b> Es enfermedad laboral la contraída como resultado de la exposición a
                    factores de riesgo inherentes a la actividad laboral o del medio en el que el trabajador se ha visto
                    obligado a trabajar. <br />
                    <b>Evaluación del riesgo:</b> Proceso para determinar el nivel de riesgo, asociado al nivel de
                    probabilidad y el nivel de consecuencia <br />
                    <b>Exposición:</b> Situación en la cual las personas se exponen a los peligros. Identificación del
                    peligro. Proceso para reconocer si existe un peligro y definir sus características. <br />
                    <b>Incidente:</b> Evento(s) relacionado(s) con el trabajo, en el (los) que ocurrió o pudo haber
                    ocurrido lesión o enfermedad (independiente de su severidad) o víctima mortal. <br />
                    <b>Lugar de trabajo:</b> Cualquier espacio físico en el que se realizan actividades relacionadas con
                    el trabajo, bajo el control de la organización. <br />
                    <b>Medida(s) de control:</b> Medida(s) implementada(s) con el fin de minimizar la ocurrencia de
                    incidentes. <br />
                    <b>Nivel de deficiencia (ND):</b> Es la magnitud de la relación esperable entre (1) el conjunto de
                    peligros detectados y su relación causal directa con posibles incidentes y (2) con la eficacia de las
                    medidas preventivas existentes en un lugar de trabajo. <br />
                    <b>Nivel de exposición (NE):</b> Es la situación de exposición a un riesgo que se presenta en un
                    tiempo determinado durante la jornada laboral. <br />
                    <b>Nivel de probabilidad (NP):</b> Es el producto del nivel de deficiencia por el nivel de exposición.
                    <br />
                    <b>Nivel de consecuencia (NC):</b> Es una medida de la severidad de las consecuencias (véase el
                    numeral 2.6). <br />
                    <b>Nivel de riesgo:</b> Magnitud de un riesgo resultante del producto del nivel de probabilidad por el
                    nivel de consecuencia. <br />
                    <b>Peligro:</b> Fuente, situación o acto con potencial de daño en términos de enfermedad o lesión a
                    las personas, o una combinación de estos. <br />
                    <b>Personal expuesto:</b> Número de personas expuestas directamente a un(os) peligro(s). <br />
                    <b>Probabilidad:</b> Grado de posibilidad de que ocurra un evento no deseado y pueda producir
                    consecuencias. <br />
                    <b>Riesgo:</b> Combinación de la probabilidad de que ocurra un(os) evento(s) o exposición(es)
                    peligroso(s), y la severidad de lesión o enfermedad, que puede ser causado por el (los) evento(s) o
                    la(s) exposición(es). <br />
                    <b>Riesgo Aceptable:</b> Riesgo que ha sido reducido a un nivel que la organización puede tolerar con
                    respecto a sus obligaciones legales y su propia política en seguridad y salud ocupacional. <br />
                    <b>Valoración de los riesgos:</b> Proceso de evaluar el(los) riesgo(s) que surge(n) de un(os)
                    peligro(s), teniendo en cuenta la suficiencia de los controles existentes, y Procedimiento
                    Identificación de peligros.
                  </p>
                  <h4 id="list-item-4">Actividades</h4>
                  <p><b>1. Identificación de Peligros.</b> <br />
                    El responsable de la implementación del Sistema de Seguridad y Salud en el Trabajo y el Grupo SST
                    (vigía/ copasst), son los encargados de identificar los peligros y establecer las medidas de control.
                    La identificación de los peligros inicia con el análisis de los procesos, actividades y tareas que
                    hacen parte de LA EMPRESA, se deben tener en cuenta las actividades realizadas por el personal,
                    contratistas, subcontratistas y visitantes. <br />
                    La información se obtiene a través del recorrido por las diferentes áreas, inspecciones a los puestos
                    de trabajo, análisis de las tareas realizadas en cada proceso, definir si son rutinarias y no
                    rutinarias, y entrevista con los empleados expuestos a factores de peligros y riesgos. <br />
                    Se debe identificar el factor de riesgo (peligro) al que está expuesto según la actividad realizada,
                    de acuerdo con su clasificación y describir las fuentes generadoras (equipos, instalaciones,
                    sustancias químicas, actos y comportamientos, etc.) <br />
                    Determinar si el efecto posible del peligro identificado generaría un Accidente de Trabajo o una
                    Enfermedad Laboral. <br />
                    Al identificar peligros se deben tener en cuenta los siguientes aspectos:
                  <ul>
                    <li>Comportamientos del personal.</li>
                    <li>Diseño del puesto de trabajo. </li>
                    <li>Actos y/o comportamientos del personal. </li>
                    <li>Peligros originados fuera del lugar de trabajo. </li>
                    <li>Equipos, instalaciones, procedimientos. </li>
                    <li>Materiales peligrosos utilizados en las labores. </li>
                    <li>Sustancias químicas. </li>
                    <li>Creación de nuevos procesos.</li>
                    <li>Requisitos legales que puedan afectar la seguridad y la salud del personal de la entidad. </li>
                  </ul>
                  <b> 2. Identificación de los controles existentes.</b><br />
                  Identificar las medidas de control que actualmente se están ejecutando para cada uno de los peligros
                  identificados, y clasificarlos en:
                  <ul>
                    <li>Fuente</li>
                    <li>Medio</li>
                    <li>Individuo</li>
                  </ul>
                  Se deben considerar los controles administrativos que la entidad ha implementado para disminuir el
                  riesgo, como inspecciones, ajustes de procedimientos, entre otros. <br /><br />



                  <b>3. Valoración del Riesgo.</b><br />
                  Realizar la valoración del riesgo una vez identificados los peligros, la cual incluye la determinación
                  de los criterios de aceptabilidad del riesgo y la evaluación de los riesgos; teniendo en cuenta la
                  suficiencia de los controles existentes y la decisión de si son aceptables o no, con base en los
                  criterios definidos. Decidir si el riesgo es aceptable implica determinar la aceptabilidad de los
                  riesgos y decidir si los controles de Seguridad y Salud en el Trabajo (SST) existentes o planificados
                  son suficientes para mantener los riesgos bajo control y cumplir los requisitos legales. <br />

                  Criterios de Aceptabilidad del Riesgo:
                  <ul>
                    <li>Cumplimiento de los requisitos legales aplicables y otros.</li>
                    <li>Su política de Seguridad y Salud en el Trabajo.</li>
                    <li>Objetivos y metas de la entidad.</li>
                    <li>Aspectos operacionales, técnicos, financieros, sociales y otros.</li>
                    <li>Opiniones de las partes interesadas.</li>
                  </ul>

                  <b>4. Evaluación del Riesgo.</b><br />
                  Se debe evaluar los riesgos que corresponde al proceso de determinar la probabilidad de que ocurran
                  eventos específicos y la magnitud de sus consecuencias, mediante el uso sistemático de la información
                  disponible. Obtenida la información necesaria en cada centro o puesto de trabajo de la entidad se
                  procede a diseñar, ajustar y cuantificar los peligros y riesgos; y se toman para el análisis de los
                  ítems descritos en los mecanismo de evaluación del riesgo, tomando como base, la guía o metodología GUÍA
                  TÉCNICA GTC 45 2012 definida por el Organismo Nacional de Normalización de Colombia ICONTEC. <br />
                  Ver los siguientes anexos:
                  <ul>
                    <li>Anexo 3 Evaluación del Nivel de Riesgo</li>

                    <li>Anexo 4 Determinación del Nivel de Deficiencia</li>

                    <li>Anexo 5 Determinación del Nivel de Exposición </li>

                    <li>Anexo 6 Determinación del Nivel de Probabilidad </li>

                    <li>Anexo 7 Significado de los Diferentes Niveles de Probabilidad </li>

                    <li>Anexo 8 Determinación del Nivel de Consecuencias </li>

                    <li> Anexo 9 Determinación del Nivel de Riesgo </li>

                    <li> Anexo 10 Significado del Nivel de Riesgo</li>
                  </ul>

                  <b> 5. Medidas de Prevención y Control. </b><br />
                  Determinar si los controles existentes son suficientes, necesitan mejorarse o se requiere nuevos
                  controles. Con base a lo anterior se determina las acciones tendientes a controlar o disminuir el
                  riesgo, clasificándolas de acuerdo con la jerarquía de controles: <br />
                  <ul>
                    <li>Eliminación</li>

                    <li>Sustitución</li>

                    <li>Controles de Ingeniería</li>

                    <li>Controles administrativos, señalización, advertencia</li>

                    <li>EPP</li>
                  </ul>


                  Una vez determinados los controles, se debe priorizar las acciones para implementarlos. Para priorizar
                  las acciones, se debe tener en cuenta el potencial de reducción de riesgos de los controles
                  planificados. <br />
                  Para priorizar las acciones se tendrá en cuenta el nivel de riesgo, de acuerdo a los criterios
                  establecidos por la GTC 45 2012 que se describe a continuación: <br /> <br />

                  <b>Nivel de Riesgo I:</b> Se considera una situación crítica por lo tanto requiere la suspensión de
                  actividades hasta que se establezca el control. Intervención Urgente. <br />
                  <b>Nivel de Riesgo II:</b> Corregir y adoptar medidas de control de inmediato. <br />
                  <b>Nivel de Riesgo III:</b> Mejorar si es posible. Sería conveniente justificar la intervención y su
                  rentabilidad. <br />
                  <b>Nivel de Riesgo IV:</b> Mantener las medidas de control existentes, pero se deberían considerar
                  soluciones o mejoras y se deben hacer comprobaciones periódicas para asegurar que el riesgo aun es
                  aceptable. <br /><br />

                  <b> 6. Revisión y Aprobación. </b><br />
                  Una vez diligenciada la Matriz, será socializada con el responsable del Diseño del sistema de gestión
                  seguridad y salud en el trabajo, con el fin de determinar su conformidad con los riesgos identificados y
                  las actividades propuestas para el control de estos. <br /> <br />

                  <b> 7. Cambios y Actualización.</b><br />
                  La matriz debe actualizarse como mínimo una vez al año o puede generar un cambio no programado debido a:
                  <br />
                  <ul>
                    <li> Observaciones hechas por las partes interesadas.</li>

                    <li>Nuevos procesos o cambios de ingeniería. </li>

                    <li> Solicitud de acciones correctivas.</li>

                    <li>Cese de actividades o procesos que dan lugar al peligro. </li>

                    <li>Nuevos requisitos legales o modificación de los existentes. </li>

                    <li>Cuando el resultado de una investigación de una enfermedad laboral o un accidente de trabajo se
                      presente la necesidad de reevaluar los riesgos.</li>

                    <li>Cambios realizados a la infraestructura, compras de equipos y materiales, ya sean propios o
                      suministrados por terceros. </li>

                    <li>Cuando se cree, actualice o modifique un proceso, procedimiento o actividad. </li>

                    <li>Cuando se cree un nuevo cargo, se reubique personal, o se disponga de un nuevo contratista.</li>
                  </ul>


                  Para la actualización de la Matriz se tendrá en cuenta los siguientes aspectos: <br />


                  <li> Actividades rutinarias y no rutinarias.</li>

                  <li> Actividades de todas las personas que tienen acceso a la entidad. (Empleados, contratistas,
                    subcontratistas y visitantes)</li>

                  <li> Emergencias. </li>

                  <li> Los comportamientos, aptitudes y otros factores humanos. </li>

                  <li> Los peligros identificados que se originan fuera del lugar del trabajo y que estén bajo el control
                    de la Gobernación. </li>

                  <li> Modificaciones al sistema SST. </li>

                  <li> Cualquier obligación legal aplicable relacionada con la valoración del riesgo y la implementación
                    de los controles. </li>

                  <li> El diseño de áreas de trabajo.</li> <br />

                  Para verificar su cumplimiento se debe registrar la última fecha de actualización, los cambios o
                  actualizaciones aplicadas y el responsable del diligenciamiento. <br /> <br />

                  <b> 8. Seguimiento de las Medidas de Prevención y Control.</b> <br />

                  Realizar una revisión periódica para asegurar la coherencia y eficacia de los controles propuestos,
                  mediante visitas e inspecciones a los puestos de trabajo, seguimiento a las actividades de los programas
                  de gestión, eficacia de las capacitaciones, etc. <br />

                  Los resultados de la revisión pueden mostrar que no es necesario realizar nuevas evaluaciones de
                  riesgos, ya que los controles existentes propuestos siguen siendo válidos. <br />

                  Estas revisiones deben ser evidenciadas en el cronograma de actividades de los Sistemas Integrados de
                  Gestión o en las acciones correctivas o preventivas. <br /> <br />





                  <b>9. Comunicar Riesgos. </b> <br />

                  Se divulga la Matriz a todo el personal de la entidad involucrado, así mismo se comunica a los
                  contratistas y visitantes los riesgos a los cuales están expuestos y las medidas de control que se
                  implementan para la mitigación de los mismos. Cada vez que se realice una actualización de la matriz, se
                  debe hacer la respectiva comunicación al personal implicado. <br />
                  <b>SALIDAS DEL PROCEDIMIENTO </b> <br />
                  Matriz de Identificación de Peligros, Evaluación y control de Riesgos </p>
                  <br />
                  <h5 class="text-center">ANEXO 1</h5>
                  <h5 class="text-center">CLASIFICACIÓN DE LOS FACTORES DE RIESGOS</h5><br /><br />
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th colspan="2" class="text-center">FÌSICO: Se refiere a todos aquellos factores ambientales que
                          dependen de las propiedades físicas de los cuerpos, tales como carga física, ruido, iluminación,
                          radiación ionizante, radiación no ionizante, temperatura elevada y vibración, que actúan sobre
                          los tejidos y órganos del cuerpo del trabajador y que pueden producir efectos nocivos, de
                          acuerdo con la intensidad y tiempo de exposición de estos.</th>
                      </tr>
                      <tr>
                        <th class="text-center">FACTOR DE RIESGO</th>
                        <th class="text-center">FUENTE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="m-5" rowspan="2">Iluminación</td>
                        <td>Luz Natural (El sol)</td>
                      </tr>
                      <tr>
                        <td>Luz Artificial (Lámparas, fluorescentes, bombillos)</td>
                      </tr>
                      <tr>
                        <td class="m-5" rowspan="3">Ruido</td>
                        <td>De Impacto </td>
                      </tr>
                      <tr>
                        <td>Continuo</td>
                      </tr>
                      <tr>
                        <td>Intermitente</td>
                      </tr>
                      <tr>
                        <td>Radiaciones No Ionizantes</td>
                        <td>Radiofrecuencia</td>
                      </tr>
                      <tr>
                        <td class="m-5" rowspan="2">Temperaturas Elevadas</td>
                        <td>Altas (Calor)</td>
                      </tr>
                      <tr>
                        <td>Bajas (Frío)</td>
                      </tr>
                      <tr>
                        <td>Vibraciones</td>
                        <td>Bajas frecuencias</td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr>
                        <th colspan="2" class="text-center">QUÍMICO: Se refiere a los elementos o sustancias orgánicas e
                          inorgánicas que durante la fabricación, transporte, manejo, almacenamiento o uso, puedan
                          ingresar al organismo por inhalación, absorción o ingestión y dependiendo de su concentración y
                          el tiempo de exposición, pueden generar lesiones sistémicas, intoxicaciones o quemaduras.</th>
                      </tr>
                      <tr>
                        <th class="text-center">FACTOR DE RIESGO</th>
                        <th class="text-center">FUENTE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="m-5" rowspan="2">Polvos y Humos</td>
                        <td>Combustibles y químicos</td>
                      </tr>
                      <tr>
                        <td>Material Particulado</td>
                      </tr>
                      <tr>
                        <td>Líquidos, vapores, rocío, humos o gases perceptibles organolépticamente</td>
                        <td>Combustibles y químicos </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr>
                        <th colspan="2" class="text-center">BIOLÓGICOS: Se refiere a micro y macro organismos patógenos y
                          a los residuos, que por sus características físico – químicos, pueden ser tóxicos para las
                          personas que entren en contacto con ellos, desencadenando enfermedades infectocontagiosas,
                          reacciones alérgicas o intoxicaciones.</th>
                      </tr>
                      <tr>
                        <th class="text-center">FACTOR DE RIESGO</th>
                        <th class="text-center">FUENTE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Virus</td>
                        <td>Desechos o componentes animales</td>
                      </tr>
                      <tr>
                        <td>Bacterias</td>
                        <td>Desechos o componentes animales</td>
                      </tr>
                      <tr>
                        <td>Hongos</td>
                        <td>Desechos o componentes vegetales</td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr>
                        <th colspan="2" class="text-center">DE SEGURIDAD: Se refiere a todos aquellos objetos, máquinas,
                          equipos y herramientas, que por sus condiciones de funcionamiento diseño y ubicación, tienen la
                          capacidad potencial de entrar en contacto , diseñó, estado, o, por la forma, tamaño con las
                          personas, provocando daños o lesiones.</th>
                      </tr>
                      <tr>
                        <th class="text-center">FACTOR DE RIESGO</th>
                        <th class="text-center">FUENTE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Incendios y explosión</td>
                        <td>Combustibles y químicos</td>
                      </tr>
                      <tr>
                        <td class="m-5" rowspan="5">Eléctricos</td>
                        <td>Alta tensión</td>
                      </tr>
                      <tr>
                        <td>Baja tensión</td>
                      </tr>
                      <tr>
                        <td>Electricidad estática</td>
                      </tr>
                      <tr>
                        <td>Cableado</td>
                      </tr>
                      <tr>
                        <td>Tomas</td>
                      </tr>
                      <tr>
                        <td class="m-5" rowspan="7">Instalaciones locativas</td>
                        <td>Estructuras</td>
                      </tr>
                      <tr>
                        <td>Instalaciones</td>
                      </tr>
                      <tr>
                        <td>Superficies de trabajo</td>
                      </tr>
                      <tr>
                        <td>Orden y aseo</td>
                      </tr>
                      <tr>
                        <td>Demarcación de áreas</td>
                      </tr>
                      <tr>
                        <td>Escaleras inapropiadas</td>
                      </tr>
                      <tr>
                        <td>Distribución del espacio</td>
                      </tr>
                      <tr>
                        <td class="m-5" rowspan="6">Mecánicos</td>
                        <td>Atrapamiento</td>
                      </tr>
                      <tr>
                        <td>Proyección de materiales</td>
                      </tr>
                      <tr>
                        <td>Manejo de elementos cortantes, punzantes o contundentes</td>
                      </tr>
                      <tr>
                        <td>Manejo de materiales calientes</td>
                      </tr>
                      <tr>
                        <td>Trabajo con mecanismos o partes abrasivos en movimiento</td>
                      </tr>
                      <tr>
                        <td>Trabajo en alturas</td>
                      </tr>
                      <tr>
                        <td class="m-5" rowspan="3">Almacenamiento</td>
                        <td>Clasificación y rotulación</td>
                      </tr>
                      <tr>
                        <td>Apilamiento</td>
                      </tr>
                      <tr>
                        <td>Espacio</td>
                      </tr>
                      <tr>
                        <td class="m-5" rowspan="4">Seguridad personal</td>
                        <td>Al exterior de la empresa</td>
                      </tr>
                      <tr>
                        <td>Amenazas sociales</td>
                      </tr>
                      <tr>
                        <td>Amenazas naturales</td>
                      </tr>
                      <tr>
                        <td>Riesgos inherentes al desplazamiento (mensajeros-conductores)</td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr>
                        <th colspan="2" class="text-center">BIOMECANICOS: Se refiere a los elementos o sustancias
                          orgánicas e inorgánicas que durante la fabricación, transporte, manejo, almacenamiento o uso,
                          puedan ingresar al organismo por inhalación, absorción o ingestión y dependiendo de su
                          concentración y el tiempo de exposición, pueden generar lesiones sistemáticas, intoxicaciones o
                          quemaduras.</th>
                      </tr>
                      <tr>
                        <th class="text-center">FACTOR DE RIESGO</th>
                        <th class="text-center">FUENTE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="m-5" rowspan="3">Carga Estática</td>
                        <td>Postura fija sostenida de la jornada</td>
                      </tr>
                      <tr>
                        <td>De pie</td>
                      </tr>
                      <tr>
                        <td>Sentado</td>
                      </tr>
                      <tr>
                        <td class="m-5" rowspan="4">Carga Dinámica</td>
                        <td>Movilización de cargas</td>
                      </tr>
                      <tr>
                        <td>Empujar-halar cargas</td>
                      </tr>
                      <tr>
                        <td>Trabajo en superficies inclinadas y escaleras</td>
                      </tr>
                      <tr>
                        <td>Tareas de alto desgaste físico</td>
                      </tr>
                      <tr>
                        <td class="m-5" rowspan="6">Postura crítica</td>
                        <td>Posturas forzadas sostenidas o repetidas</td>
                      </tr>
                      <tr>
                        <td>Movimientos de rotación, inclinación lateral o ante posterior e hiper extensión verticalmente
                        </td>
                      </tr>
                      <tr>
                        <td>Inadecuada distancia ojo-pantalla</td>
                      </tr>
                      <tr>
                        <td>Pantalla sin filtro</td>
                      </tr>
                      <tr>
                        <td>Ausencia de apoyo de antebrazos</td>
                      </tr>
                      <tr>
                        <td>Pantalla monocromática </td>
                      </tr>

                      <tr>
                        <td class="m-5" rowspan="2">Diseño del puesto de trabajo</td>
                        <td>Diseño inadecuado de las sillas</td>
                      </tr>
                      <tr>
                        <td>Espacio de trabajo insuficiente</td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr>
                        <th colspan="2" class="text-center">PSICOSOCIALES: Se refiere a la interacción de los aspectos
                          propios de las personas (edad, patrimonio genético, estructura sociológica, historia, vida
                          familiar, cultura) con las modalidades de gestión administrativa y demás aspectos
                          organizacionales inherentes al tipo de proceso productivo. La dinámica de dicha interacción se
                          caracteriza especialmente por la capacidad potencial.</th>
                      </tr>
                      <tr>
                        <th class="text-center">FACTOR DE RIESGO</th>
                        <th class="text-center">FUENTE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="m-5" rowspan="7">Condiciones de la tarea</td>
                        <td>Apremio de tiempo</td>
                      </tr>
                      <tr>
                        <td>Atención al público</td>
                      </tr>
                      <tr>
                        <td>Atención y concentración elevada</td>
                      </tr>
                      <tr>
                        <td>Alta responsabilidad</td>
                      </tr>
                      <tr>
                        <td>Complejidad rapidez</td>
                      </tr>
                      <tr>
                        <td>Monotonía e imposibilidad de crear</td>
                      </tr>
                      <tr>
                        <td>Sensación de peligro</td>
                      </tr>
                    </tbody>
                  </table>

                  <br />
                  <h5 class="text-center">ANEXO 2</h5>
                  <h5 class="text-center">DESCRIPCIÓN DE LOS NIVELES DE DAÑO</h5>
                  <img class="ml-5" style="position: center;" src="@/assets/images/imag1.png" width="700"
                    height="381"><br /><br />
                  <br />
                  <h5 class="text-center">ANEXO 3</h5>
                  <h5 class="text-center">EVALUAR EL NIVEL DEL RIESGO</h5>
                  <img class="ml-5" style="position: center;" src="@/assets/images/imag2.png" width="700"
                    height="281"><br /><br />
                  <br />
                  <h5 class="text-center">ANEXO 4</h5>
                  <h5 class="text-center">DETERMINACIÓN DEL NIVEL DE DEFICIENCIA</h5>
                  <img class="ml-5" style="position: center;" src="@/assets/images/imag3.png" width="700"
                    height="381"><br /><br />
                  <br />
                  <h5 class="text-center">ANEXO 5</h5>
                  <h5 class="text-center">DETERMINACIÓN DEL NIVEL DE EXPOSICIÓN</h5>
                  <img class="ml-5" style="position: center;" src="@/assets/images/imag5.png" width="700"
                    height="281"><br /><br />
                  <br />
                  <h5 class="text-center">ANEXO 6</h5>
                  <h5 class="text-center">DETERMINACIÓN DEL NIVEL DE PROBABILIDAD</h5>
                  <img class="ml-5" style="position: center;" src="@/assets/images/imag6.png" width="700"
                    height="281"><br /><br />
                  <br />
                  <h5 class="text-center">ANEXO 7</h5>
                  <h5 class="text-center">SIGNIFICADO DE LOS DIFERENTES NIVELES DE PROBABILIDAD</h5>
                  <img class="ml-5" style="position: center;" src="@/assets/images/imag8.png" width="700"
                    height="381"><br /><br />
                  <br />
                  <h5 class="text-center">ANEXO 8</h5>
                  <h5 class="text-center">DETERMINACIÓN DEL NIVEL DE CONSECUENCIA</h5>
                  <img class="ml-5" style="position: center;" src="@/assets/images/imag7.png" width="700"
                    height="281"><br /><br />
                  <br />
                  <h5 class="text-center">ANEXO 9</h5>
                  <h5 class="text-center">DETERMINACIÓN DEL NIVEL DE RIESGO</h5>
                  <img class="ml-5 pl-5" style="position: center;" src="@/assets/images/imag9.png" width="600"
                    height="281"><br /><br />
                  <br />
                  <h5 class="text-center">ANEXO 10</h5>
                  <h5 class="text-center">SIGNIFICADO DEL NIVEL DE RIESGO</h5>
                  <img class="ml-5" style="position: center;" src="@/assets/images/imag10.png" width="700"
                    height="281"><br /><br />

                  <!-- <h4  id="list-item-5">Item 5</h4>
                  <p>{{ text }}</p>
                   <h4 id="list-item-6">Item 6</h4>
                  <p>{{ text }}</p> -->

                  <h4 hidden id="list-item-5"></h4>
                  <p></p>
                  <h4 hidden id="list-item-6"></h4>
                  <p></p>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
